import {
  createTrigger as publicCreateTrigger,
  updateTrigger as publicUpdateTrigger,
  deleteTriggerByAppIdAndKey as publicDeleteTriggerByAppIdAndKey,
  getTriggerByAppIdAndKey as publicGetTriggerByAppIdAndKey,
  queryTriggers as publicQueryTriggers,
  typedQueryTriggers as publicTypedQueryTriggers,
  resolveTriggers as publicResolveTriggers,
  getTriggerDynamicSchema as publicGetTriggerDynamicSchema,
  getIdentitiesSchema as publicGetIdentitiesSchema,
} from './automations-triggercatalog-v1-trigger-trigger-catalog.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ResultsQueryBuilder,
  TriggerQuery,
  typedQueryTriggers as universalTypedQueryTriggers,
} from './automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';

function customQueryTriggers(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryTriggers(httpClient)(),
    typedQueryFunction: (query: TriggerQuery) =>
      publicTypedQueryTriggers(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ResultsQueryBuilder;
  function overloadedQuery(
    query: TriggerQuery
  ): ReturnType<typeof universalTypedQueryTriggers>;
  function overloadedQuery(query?: TriggerQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createTrigger: MaybeContext<
  BuildRESTFunction<typeof publicCreateTrigger> & typeof publicCreateTrigger
> = /*#__PURE__*/ createRESTModule(publicCreateTrigger);
export const updateTrigger: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTrigger> & typeof publicUpdateTrigger
> = /*#__PURE__*/ createRESTModule(publicUpdateTrigger);
export const deleteTriggerByAppIdAndKey: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTriggerByAppIdAndKey> &
    typeof publicDeleteTriggerByAppIdAndKey
> = /*#__PURE__*/ createRESTModule(publicDeleteTriggerByAppIdAndKey);
export const getTriggerByAppIdAndKey: MaybeContext<
  BuildRESTFunction<typeof publicGetTriggerByAppIdAndKey> &
    typeof publicGetTriggerByAppIdAndKey
> = /*#__PURE__*/ createRESTModule(publicGetTriggerByAppIdAndKey);
export const resolveTriggers: MaybeContext<
  BuildRESTFunction<typeof publicResolveTriggers> & typeof publicResolveTriggers
> = /*#__PURE__*/ createRESTModule(publicResolveTriggers);
export const getTriggerDynamicSchema: MaybeContext<
  BuildRESTFunction<typeof publicGetTriggerDynamicSchema> &
    typeof publicGetTriggerDynamicSchema
> = /*#__PURE__*/ createRESTModule(publicGetTriggerDynamicSchema);
export const getIdentitiesSchema: MaybeContext<
  BuildRESTFunction<typeof publicGetIdentitiesSchema> &
    typeof publicGetIdentitiesSchema
> = /*#__PURE__*/ createRESTModule(publicGetIdentitiesSchema);
export const queryTriggers: MaybeContext<
  BuildRESTFunction<typeof customQueryTriggers> & typeof customQueryTriggers
> = /*#__PURE__*/ createRESTModule(customQueryTriggers);

export {
  TimeUnit,
  Segment,
  SourceType,
  Maturity,
  ValueInputType,
  Type,
  FieldKeyType,
  ExperimentActionType,
  SortOrder,
  WebhookIdentityType,
} from './automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';
export {
  Trigger,
  DomainEventOptions,
  Filter,
  FilterFieldKeyOneOf,
  EntitySelector,
  UserInput,
  UserInputInputOptionsOneOf,
  NumberInputOptions,
  BooleanInputOptions,
  StaticItems,
  StaticItemValue,
  DynamicFieldKey,
  ValueInput,
  ValueInputInputOptionsOneOf,
  Metadata,
  ImplementedMethods,
  DebounceConfiguration,
  Source,
  SourceOptionsOneOf,
  RetryExperimentCreation,
  TriggerSpecInfo,
  TriggerDeletedWithEntity,
  CreateTriggerRequest,
  CreateTriggerResponse,
  GetTriggerRequest,
  GetTriggerResponse,
  UpdateTriggerRequest,
  UpdateTriggerResponse,
  UpdateTriggerComponentRequest,
  UpdateTriggerComponentResponse,
  UpdateTriggerMaturityRequest,
  UpdateTriggerMaturityResponse,
  DeleteTriggerRequest,
  DeleteTriggerResponse,
  DeleteTriggerByAppIdAndKeyRequest,
  DeleteTriggerByAppIdAndKeyResponse,
  MigrateComponentToTriggerRequest,
  MigrateComponentToTriggerResponse,
  RemoveComponentDataRequest,
  RemoveComponentDataResponse,
  GetTriggerByAppIdAndKeyRequest,
  GetTriggerByAppIdAndKeyResponse,
  GetRuntimeTriggerRequest,
  GetRuntimeTriggerResponse,
  GetLatestTriggerRequest,
  GetLatestTriggerResponse,
  QueryRuntimeTriggersRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryRuntimeTriggersResponse,
  PagingMetadataV2,
  Cursors,
  QueryTriggersRequest,
  QueryTriggersResponse,
  ResolveTriggersRequest,
  ResolveTriggersResponse,
  GetTriggerDynamicSchemaRequest,
  SelectedFilterOptions,
  GetDynamicSchemaResponse,
  GetIdentitiesSchemaRequest,
  GetIdentitiesSchemaResponse,
  ListMarketplaceAndWhitelistTriggersRequest,
  ListMarketplaceAndWhitelistTriggersResponse,
  ListWhitelistTriggerAppsRequest,
  ListWhitelistTriggerAppsResponse,
  BulkCreateWhitelistTriggerAppsRequest,
  BulkCreateWhitelistTriggerAppsResponse,
  BulkDeleteWhitelistTriggerAppsRequest,
  BulkDeleteWhitelistTriggerAppsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateTriggerOptions,
  UpdateTriggerOptions,
  DeleteTriggerByAppIdAndKeyOptions,
  GetTriggerByAppIdAndKeyIdentifiers,
  GetTriggerByAppIdAndKeyOptions,
  ResultsQueryResult,
  ResultsQueryBuilder,
  TriggerQuerySpec,
  ResolveTriggersOptions,
  GetTriggerDynamicSchemaOptions,
} from './automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';
export { utils } from './automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';
export {
  TimeUnitWithLiterals,
  SegmentWithLiterals,
  SourceTypeWithLiterals,
  MaturityWithLiterals,
  ValueInputTypeWithLiterals,
  TypeWithLiterals,
  FieldKeyTypeWithLiterals,
  ExperimentActionTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  TriggerQuery,
} from './automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';
